import { render, staticRenderFns } from "./EpicentralMaterial.vue?vue&type=template&id=61590f46&scoped=true"
import script from "./EpicentralMaterial.vue?vue&type=script&lang=js"
export * from "./EpicentralMaterial.vue?vue&type=script&lang=js"
import style0 from "./EpicentralMaterial.vue?vue&type=style&index=0&id=61590f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61590f46",
  null
  
)

export default component.exports